/** Copy for retirement income target vs inflation (real vs nominal mental model). */

export const RETIREMENT_TARGET_FOOTNOTE =
  "Your target retirement income is in today’s pounds (real terms): the lifestyle that amount buys now, not a future bank-statement figure. OnTrack sizes your plan to that spending power at retirement—you do not need to enter a higher target just because prices rise. Switch charts to Nominal to see what the same target looks like in future headline £, using your CPI assumption from Settings.";

export const RETIREMENT_TARGET_HELP_INTRO =
  "Most people think about retirement income in one of two ways. OnTrack uses the first by default.";
